import { connect } from 'react-redux';
import { ActionCreator } from 'redux';

import { actions } from '../../../state/filterActions';
import { fetchResults } from '../../../state/resultActions';

import { OverrideValues, PaleState } from '../../../interfaces';
import { RangeSlider, RangeSliderDispatchProps, RangeSliderStateProps } from './RangeSlider';

export const mapStateToProps = (state: PaleState): RangeSliderStateProps => ({
    id: 'PriceFilter',
    label: 'Pris',
    min: 0,
    max: 100000,
    stepSize: 50,
    initialValues: state.filters.priceRange,
    resetOnDefault: true,
    metric: 'kr',
    displayLabel: false,
});

export const mapDispatchToProps: OverrideValues<RangeSliderDispatchProps, ActionCreator<unknown>> = {
    onChange: actions.filterPriceRange,
    triggerFetch: fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(RangeSlider);
